// extracted by mini-css-extract-plugin
export var aggregationCell = "_64-n";
export var aggregationRow = "_64-m";
export var borderlessSpinnerContainer = "_64-3";
export var cardLayout = "_64-6";
export var cardLayoutNoFooter = "_64-9";
export var cardLayoutPageControl = "_64-8";
export var closeIcon = "_64-f";
export var columnHeaderSurface = "_64-b";
export var columnHeaderSurfaceDragOverlay = "_64-v";
export var columnHeaderSurfaceResizing = "_64-s";
export var contextMenuAnchor = "_64-1";
export var draggableColumnHeader = "_64-t";
export var draggableColumnHeaderOverlay = "_64-u";
export var expandIcon = "_64-g";
export var expanded = "_64-h";
export var filterDropdown = "_64-i";
export var filterDropdownDivider = "_64-d";
export var filterDropdownHeader = "_64-l";
export var filterDropdownItem = "_64-k";
export var filterDropdownModal = "_64-j _64-i";
export var filterItem = "_64-c";
export var normalCellWithAdjustableBorder = "_64-e";
export var pinButtonContainer = "_64-o";
export var pinIcon = "_64-p";
export var pinIconActive = "_64-q";
export var spinner = "_64-0";
export var spinnerContainer = "_64-2";
export var tableContainer = "_64-4";
export var tableContentDraggingColumns = "_64-a";
export var tableContentInner = "_64-7";
export var tableContentWrapper = "_64-5";
export var viewButtonContainer = "_64-r";